<script>
import VueCharts from 'vue-chartjs';
import { Radar } from 'vue-chartjs';

const chartOptionsDefault = {
  colorText: '#ffffff',
  colorStroke: '#ffffff',
  colorOverlay: 'rgba(121, 172, 43, 80%)',
};

export default {
  extends: Radar,
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    chartOptions: {
      type: Object,
      default() {
        return chartOptionsDefault;
      },
    },
  },
  data() {
    return {
      dataset: {
        borderWidth: 0,
        backgroundColor: this.chartOptions.colorOverlay || chartOptionsDefault.colorOverlay,
        data: [],
        spanGaps: true,
        pointRadius: 0,
        pointRotation: 90,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scale: {
          scaleLabel: {
            display: false,
          },
          ticks: {
            display: false,
            suggestedMin: 0,
            suggestedMax: 100,
            stepSize: 25,
          },
          angleLines: {
            color: this.chartOptions.colorStroke || chartOptionsDefault.colorStroke,
            lineWidth: 2,
          },
          pointLabels: {
            fontColor: this.chartOptions.colorText || chartOptionsDefault.colorText,
            fontFamily: 'Klavika, MiriadPro, sans-serif',
            fontSize: 11,
          },
          gridLines: {
            color: this.chartOptions.colorStroke || chartOptionsDefault.colorStroke,
            drawBorder: true,
          },
        },
        legend: {
          display: false,
        },
      },
    };
  },
  mounted() {
    let list = this.list;
    if (typeof this.list === 'string') {
      list = JSON.parse(this.list);
    }

    const data = {
      labels: list?.map((item) => item.label),
      datasets: [
        {
          ...this.dataset,
          data: list?.map((item) => item.value),
        },
      ],
    };
    this.renderChart(data, this.options);
  },
};
</script>
